cv.FieldView = Marionette.LayoutView.extend({
  regions: {},

  events: {
    "keyup input": "embedMedia",
    "keyup .cv-field-content": "keyupField",
    "click .cv-field-content": "focusField",

    "click .cv-field-insert": "insertField",
    "click .cv-field-edit": "editField",
    "click .cv-field-remove": "removeField",
    "click .cv-field-cancel": "cancelField",
  },

  keyupField: function () {
    if (this.$el.hasClass("cv-text-line")) {
      if (this.$(".cv-field-content").html() == "") {
        this.$(".cv-field-content").html("&nbsp;&nbsp;&nbsp;&nbsp;");
      }

      this.model.set("value", this.$(".cv-field-content").html());
    }
  },

  focusField: function (e) {
    e.preventDefault();
    e.stopPropagation();

    // Unbind and remove active border
    vent.trigger("editor:clear_fields");
    this.$el.addClass("cv-active");

    // Fire the toolbar
    if (this.$el.hasClass("cv-text-block")) {
      parent.cv.iframeTrigger("editor:show_toolbar");
    } else {
      parent.cv.iframeTrigger("editor:hide_toolbar");
    }
  },

  initialize: function (options) {
    this.options = _.extend(this.options, options);

    // Add the outline
    this.$el.prepend(
      '<div class="cv-field-outline"><div class="cv-field-label">' +
        this.$el.data("label") +
        "</div></div>",
    );

    // Bind listenener to clear
    this.listenTo(
      vent,
      "editor:clear_fields",
      function () {
        this.$el.removeClass("cv-active");
      },
      this,
    );

    // Bind any image or media regions
    if (this.$el.hasClass("cv-image") || this.$el.hasClass("cv-media")) {
      this.$el.prepend(cv.Templates["preview/field_controls"]());

      // Bind the change event
      this.listenTo(this.model, "change:value", this.renderField, this);

      // Fire off initial render for controls
      this.renderControls();
    }
    if (this.$el.hasClass("cv-text-block")) {
      this.bindTextBlock();
    }
    if (this.$el.hasClass("cv-text-line")) {
      this.bindTextLine();
    }

    this.$(".fileupload").fileupload({
      url: "//causevox-production.s3.amazonaws.com",
      paramName: "file",
      beforeSend: function (jqXHR) {},
      add: _.bind(function (e, data) {
        var upload_errors = 0;
        var acceptFileTypes = /^image\/(gif|jpe?g|png)$/i;
        if (
          data.originalFiles[0]["type"] == "" ||
          !acceptFileTypes.test(data.originalFiles[0]["type"])
        ) {
          parent.cv.iframeTrigger("notif:error", "That file is not a valid image.");
          upload_errors++;
        }
        if (data.originalFiles[0]["size"] == "" || data.originalFiles[0]["size"] > 5000000) {
          parent.cv.iframeTrigger(
            "notif:error",
            "That file is too large.  Please upload a file under 5 MB.",
          );
          upload_errors++;
        }
        if (upload_errors == 0) {
          // Generate the policy
          $.ajax({
            url: "/v1/editor/generate_policy",
            type: "POST",
            data: {
              file_extension: data.originalFiles[0].name.split(".").pop(),
            },
            dataType: "json",
            async: false,
            beforeSend: function (jqXHR) {
              jqXHR.setRequestHeader("Apikey", cv.PRELOADED.api_key);
            },
            success: _.bind(function (response) {
              data.formData = {
                key: response.key,
                AWSAccessKeyId: response.access_key,
                policy: response.policy,
                signature: response.signature,
                acl: "public-read",
                success_action_status: "201",
                "X-Requested-With": "xhr",
                "Content-Type": data.originalFiles[0].name.split(".").pop(),
              };
            }, this),
            error: _.bind(function (result, textStatus, jqXHR) {
              parent.cv.iframeTrigger(
                "notif:error",
                "There was an error generating the S3 policy.",
              );
              return false;
            }, this),
          });

          data.submit();
        }
      }, this),
      send: _.bind(function (result, textStatus, jqXHR) {
        parent.cv.iframeTrigger("notif:success", "Uploading...");
      }, this),
      success: _.bind(function (result, textStatus, jqXHR) {
        var s3_key = "/" + $(jqXHR.responseXML).find("Key").text();
        var s3_url = $(jqXHR.responseXML).find("Location").text();

        this.model.unset("html");
        this.model.set({
          value: s3_key,
        });
        parent.cv.iframeTrigger("notif:success", "Your image was uploaded.");
      }, this),
      error: _.bind(function (result, textStatus, jqXHR) {
        parent.cv.iframeTrigger("notif:error", "There was an error uploading your file.");
      }, this),
    });

    // Bind the save
    this.listenTo(
      this.model,
      "change:value",
      function (model) {
        if (window.name == "cv_editor") {
          parent.cv.iframeTrigger("editor:save_field", model);
        }
      },
      this,
    );

    console.log("FieldView initialized");
  },

  templateHelpers: function () {
    return {};
  },

  // For the media embed
  insertField: function (e) {
    e.preventDefault();

    this.$(".cv-field-control").hide();
    this.$(".cv-field-control-embed").show();
    this.$(".cv-field-control-embed input").html("").focus();
  },

  // For the media embed
  cancelField: function (e) {
    e.preventDefault();

    this.$(".cv-field-control").hide();
    this.$(".cv-field-control-media").show();
  },

  embedMedia: function (e) {
    if (e.keyCode != 13) return;

    var url = this.$("input[type=text]").val();

    if (!/^https?:\/\//i.test(url)) {
      parent.cv.iframeTrigger(
        "notif:error",
        "Please make sure your URL has the format https://...",
      );
      return;
    }

    // Generate the policy
    $.ajax({
      url:
        "https://cdn.iframe.ly/api/oembed?url=" +
        encodeURIComponent(url) +
        "&key=a8fc150b70146aa1998c4e1b320becdf",
      type: "GET",
      dataType: "json",
      beforeSend: function (jqXHR) {},
      success: _.bind(function (response) {
        console.log(response);

        if (response.status == 404) {
          parent.cv.iframeTrigger(
            "notif:error",
            "We had an issue trying to embed this content.  Please check the URL or contact support.",
          );
          return;
        }

        if (response.type == "image" || response.type == "photo") {
          this.model.set({
            value: response.url,
          });
        } else if (response.type == "video" || response.type == "rich") {
          this.model.set({
            value: response.url,
            html: response.html,
          });
        } else {
          parent.cv.iframeTrigger(
            "notif:error",
            "We had an issue trying to embed this content.  Please check the URL or contact support.",
          );
          return;
        }
      }, this),
      error: _.bind(function (result, textStatus, jqXHR) {
        parent.cv.iframeTrigger(
          "notif:error",
          "We had an issue trying to embed this content.  Please check the URL or contact support.",
        );
        return;
      }, this),
    });
  },

  renderControls: function () {
    this.$(".cv-field-control").hide();

    if (this.model.get("value") != "") {
      this.$(".cv-field-control-full").show();
    } else {
      this.$(".cv-field-content").html('<div class="cv-placeholder"></div>');

      if (this.$el.hasClass("cv-image")) {
        this.$(".cv-field-control-upload").show();
      }
      if (this.$el.hasClass("cv-media")) {
        this.$(".cv-field-control-media").show();
      }
    }
  },

  renderField: function () {
    if (this.model.get("value") != "") {
      if (this.$el.hasClass("cv-image")) {
        setTimeout(
          _.bind(function () {
            $(this).remove(); // prevent memory leaks as @benweet suggested

            // Render
            this.$(".cv-field-content").html(
              '<div class="media media-photo">' +
                cv.photo({
                  photo_path: this.model.get("value"),
                  transforms: {
                    fit: "crop",
                  },
                }) +
                "</div>",
            );

            setTimeout(
              _.bind(function () {
                imgix.fluid(this.$el.get(0), {
                  rootNode: this.$el.get(0),
                  autoInsertCSSBestPractices: true,
                });
              }, this),
              10,
            );
          }, this),
          250,
        );
      }
      if (this.$el.hasClass("cv-media")) {
        if (!_.isUndefined(this.model.get("html"))) {
          this.$(".cv-field-content").html(
            '<div class="media media-video">' + this.model.get("html") + "</div>",
          );
        } else {
          setTimeout(
            _.bind(function () {
              $(this).remove(); // prevent memory leaks as @benweet suggested

              // Render
              this.$(".cv-field-content").html(
                '<div class="media media-photo">' +
                  cv.photo({
                    photo_path: this.model.get("value"),
                    transforms: {
                      fit: "crop",
                    },
                  }) +
                  "</div>",
              );

              setTimeout(
                _.bind(function () {
                  imgix.fluid(this.$el.get(0), {
                    rootNode: this.$el.get(0),
                    autoInsertCSSBestPractices: true,
                  });
                }, this),
                10,
              );
            }, this),
            250,
          );
        }
      }
    }

    this.renderControls();
  },

  removeField: function (e) {
    e.preventDefault();

    this.model.set("value", "");
  },

  bindTextBlock: function () {
    this.field_view = new cv.Views.VueComponentView({
      component: "BaseRichTextInline",
      defaultArgs: {
        props: {
          name: "E-mail content",
          modelValue: this.model.get("value"),
        },
      },
    });
    this.field_view.on(
      "value_changed",
      function (val) {
        this.model.set("value", val);
      },
      this,
    );
    this.$(".cv-field-content").html(this.field_view.render().el);

    /* CKEDITOR.InlineEditor
    .create(this.$('.cv-field-content').get(0),{
      s3Upload: {
        policyUrl: "/s3_policy"
      }
    })
    .then(_.bind(function(editor){
      editor.setData(this.model.get('value'));

      // Bind change event
      editor.model.document.on('change:data', _.bind(function(){
        this.model.set('value', editor.getData());
      }, this));
    }, this))
    .catch(function(error){
      console.error( error );
    }); */
  },

  bindTextLine: function (e) {
    this.$(".cv-field-content").prop("contenteditable", true);
  },

  onAttach: function () {},

  onDestroy: function () {
    this.field_view.remove();
    this.field_view.unbind();
  },
});
